import {
  AtlasViewBoxRequest,
  CoreApi,
  MapViewBoxRequest,
  OptionsType,
} from "@hokuto/jam-core";
import { getImageParams } from "./params.js";

export function getImageQuerystring<T extends OptionsType>(args: T) {
  const { headers } = getImageParams(args);
  const searchParams = new URLSearchParams(headers);
  searchParams.delete("Content-Type");
  return searchParams.toString();
}

export function getMapImageUrl(coreApi: typeof CoreApi.Map.Image) {
  return function getMapImageUrl(args: MapViewBoxRequest): string {
    return [coreApi(args), getImageQuerystring(args)].join("?");
  };
}

export function getAtlasImageUrl(coreApi: typeof CoreApi.Atlas.Image) {
  return function getMapImageUrl(args: AtlasViewBoxRequest): string {
    return [coreApi(args), getImageQuerystring(args)].join("?");
  };
}
